import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { IMaterial } from '../../../__core/Interfaces/IMaterial';
import { IAction } from '../../../__core/Interfaces/IAction';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import MATERIAL_ACTIONS from '../Actions/ActionTypes';
import DIRECT_ACCESS_ACTIONS from '../../DirectAccess/Actions/ActionTypes';
import { MaterialResponse } from '../Types/MaterialResponse';
import PASS_STATUS from '../../../__core/Enums/PassStatus';
import MATERIAL_ACCESS from '../../../__core/Enums/MaterialAccess';

export const materialInitState: IApiJsonResponse<IMaterial> = {
  data: {
    type: '',
    name: '',
    sourceName: '',
    id: '',
    review: null,
    status: PASS_STATUS.NOT_VISITED,
    result: null,
    tags: [],
    access: MATERIAL_ACCESS.ALL,
    progress: { done: 0, all: 0 },
    content: {
      externalUrl: '',
      html: '',
      githubUrl: '',
    },
  },
  metadata: {
    navigation: {
      contentLevel: 'chapter',
      nextChapterId: null,
      nextMaterialId: null,
      nextSlug: null,
      previousChapterId: null,
      previousMaterialId: null,
      previousSlug: null,
    },
  },
};

export const materialBase64InitState: IApiJsonResponse<string> = {
  data: '',
  metadata: {},
};

export const materialLoaderInitState = false;

export const materialBase64LoaderInitState = false;

export const currentMaterialReducer = (
  state: IApiJsonResponse<IMaterial> = materialInitState,
  action: IAction<MaterialResponse>
): MaterialResponse => {
  switch (action.type) {
    case MATERIAL_ACTIONS.FETCH_MATERIAL:
    case DIRECT_ACCESS_ACTIONS.DIRECT_ACCESS_FETCH_MATERIAL:
      return { ...action.payload };

    case MATERIAL_ACTIONS.CLEAR_MATERIAL_DETAILS:
      return materialInitState;

    default:
      return state;
  }
};

export const materialLoaderReducer = (
  state: boolean = materialLoaderInitState,
  action: IEvent
): boolean => {
  switch (action.type) {
    case MATERIAL_ACTIONS.FETCH_MATERIAL_START:
      return true;

    case MATERIAL_ACTIONS.FETCH_MATERIAL_FINISH:
      return false;

    default:
      return state;
  }
};

export const currentMaterialBase64Reducer = (
  state: IApiJsonResponse<string> = materialBase64InitState,
  action: IAction<IApiJsonResponse<string>>
): IApiJsonResponse<string> => {
  switch (action.type) {
    case MATERIAL_ACTIONS.FETCH_MATERIAL_BASE64:
      return { ...action.payload };

    default:
      return state;
  }
};
